import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function PublicBreadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6 overflow-x-auto pb-1">
      <ol className="inline-flex min-w-0 items-center gap-2 rounded-full border border-border bg-card/95 px-3 py-2 text-base font-bold shadow-xl shadow-ocean/10 backdrop-blur-xl">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.href || item.label}-${index}`} className="flex min-w-0 items-center gap-2">
              {index > 0 && <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground/60" />}
              {isLast ? (
                <span className="max-w-[14rem] truncate rounded-full bg-primary/10 px-5 py-3 text-primary md:max-w-sm">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="inline-flex items-center gap-2 rounded-full px-4 py-3 text-muted-foreground transition hover:bg-muted hover:text-foreground"
                >
                  {index === 0 && <Home className="h-4 w-4" />}
                  <span className="max-w-[10rem] truncate md:max-w-none">{item.label}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}